/**
 * @ngdoc Filter
 * @name navFilter
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .filter('advancedWidgetFilter', advancedWidgetFilter);

    /**
     * @constructor
     * @ngInject
     */
    function advancedWidgetFilter() {

        return function(widgets, widgetSearch){
            //Filter widgets based on search filter and if widget is active
            return _.filter(widgets, function(widget) {
                return widget.active && (!widgetSearch.term || widgetSearch.term.length === 0 || widget.name.toLowerCase().indexOf(widgetSearch.term.toLowerCase()) > -1);
            });
        };
    }

})();
